import { render, staticRenderFns } from "./PocDetails.vue?vue&type=template&id=49010742&scoped=true"
import script from "./PocDetails.vue?vue&type=script&lang=js"
export * from "./PocDetails.vue?vue&type=script&lang=js"
import style0 from "./PocDetails.vue?vue&type=style&index=0&id=49010742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49010742",
  null
  
)

export default component.exports